const submissionKey = 'vspots_newsletter_submission_v1';
const submissionLifetime = 10 * 60 * 1000;

class VspotsNewsletter extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    const form = this.querySelector('form');
    const dialog = this.querySelector('dialog');
    const message = this.querySelector('[data-vspots-newsletter-message]');
    const close = this.querySelector('[data-vspots-newsletter-close]');
    if (!form || !dialog || !message || !close) return;

    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => form.querySelector('button[type="submit"]')?.focus({ preventScroll: true }));

    // Shopify's CAPTCHA can complete a submission with native form.submit().
    // Keep that protected flow intact and remember only the return position.
    form.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      try {
        sessionStorage.setItem(submissionKey, JSON.stringify({
          pathname: location.pathname,
          scrollY: window.scrollY,
          createdAt: Date.now(),
        }));
      } catch {
        // The native form and confirmation still work when storage is unavailable.
      }
    }, { capture: true });

    const result = this.querySelector('[data-vspots-newsletter-error], [data-vspots-newsletter-success]');
    if (!result) return;
    message.textContent = result.textContent.trim();
    result.hidden = true;
    let submission = null;
    try {
      submission = JSON.parse(sessionStorage.getItem(submissionKey));
      sessionStorage.removeItem(submissionKey);
    } catch {
      submission = null;
    }
    const canRestore = submission?.pathname === location.pathname &&
      Number.isFinite(submission?.scrollY) && Number.isFinite(submission?.createdAt) &&
      Date.now() - submission.createdAt < submissionLifetime;
    const restorePosition = () => {
      if (canRestore) window.scrollTo({ top: submission.scrollY, behavior: 'instant' });
    };
    const url = new URL(location.href);
    url.searchParams.delete('customer_posted');
    if (url.hash === `#${form.id}`) url.hash = '';
    history.replaceState(history.state, '', url);
    requestAnimationFrame(() => {
      restorePosition();
      if (!dialog.open) dialog.showModal();
      requestAnimationFrame(restorePosition);
    });
    if (document.readyState !== 'complete') window.addEventListener('load', restorePosition, { once: true });
  }
}

if (!customElements.get('vspots-newsletter')) customElements.define('vspots-newsletter', VspotsNewsletter);
